import {
    CurrencyEnum,
    Vendor,
    User,
    CostCenter,
    BudgetPeriodEnum,
    Company,
    Expense,
    CurrencyExchange,
    BankConnection,
    Activity,
    ExpenseAccount,
    PaymentPlans,
    Payment,
    ExpenseStatusEnum,
} from "@finway-group/shared/lib/models"
import { vendorAdobeData, vendorAmazonData, vendorEbayData, vendorGoogleData, vendorMicrosoftData, vendorSlackData, vendorTelecomData } from "./data/vendors"
import {
    ceoUserData,
    cfoUserData,
    cpoUserData,
    ctoUserData,
    designerUserData,
    devInternUserData,
    devUserData,
    financeUserData,
    internUserData,
    teamLeadData,
    mainUserData,
} from "./data/users"
import {
    expenseAWSSubscription,
    expenseDataCamera,
    expenseDataCoffee,
    expenseDataDesk,
    expenseDataLamp,
    expenseDataMacbook,
    expenseDataMonitor,
    expenseDataServer,
    expenseGCPSubscription,
    expenseGithubSubscription,
    expenseMSOfficeSubscription,
    expensePrimeSubscription,
    expenseSlackSubscription,
} from "./data/expenses"
import { companyData } from "./data/company"
import { testCurrencyExchangeData } from "./data/currencyExchange"
import { bankConnection } from "./data/bankConnection"
import { expenseAccount } from "./data/expenseAccounts"
import { paymentPlan } from "./data/paymentPlan"
import { activity } from "./data/activity"
import { payment } from "./data/payment"

export class DataStore {
    public adminAccessToken: string =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmNjM5OTY5MTg0NzliNTEyNDM1ODEzNyIsImVtYWlsIjoibWF4QGdteC5kZSIsIm5hbWUiOiJNYXggTXVzdGVybWFubiIsImlzQWRtaW4iOnRydWUsImlzQXBwcm92ZXIiOmZhbHNlLCJzZXR0aW5ncyI6eyJnbG9iYWxDdXJyZW5jeSI6IlVTRCIsInNob3dFeHBlbnNlTnVtYmVycyI6dHJ1ZX0sInBvc2l0aW9uIjoiQ0VPIiwiZGVwYXJ0bWVudCI6MTQsImFwcHJvdmFscyI6W10sImlhdCI6MTYwMzM1NDY2MywiZXhwIjoxNjAzMzU0OTYzfQ.SJRQ41WKhymOy9C3mjz6bln2zZjefkKgKOUGe5hfHOI"
    public adminRefreshToken: string =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmNjM5OTY5MTg0NzliNTEyNDM1ODEzNyIsImVtYWlsIjoibWF4QGdteC5kZSIsIm5hbWUiOiJNYXggTXVzdGVybWFubiIsImlzQWRtaW4iOnRydWUsImlzQXBwcm92ZXIiOmZhbHNlLCJzZXR0aW5ncyI6eyJnbG9iYWxDdXJyZW5jeSI6IlVTRCIsInNob3dFeHBlbnNlTnVtYmVycyI6dHJ1ZX0sInBvc2l0aW9uIjoiQ0VPIiwiZGVwYXJ0bWVudCI6MTQsImFwcHJvdmFscyI6W10sImlhdCI6MTYwMzM1NDY2MywiZXhwIjoxNjAzNDQxMDYzfQ.G1SlnN3OMaRcWeYYPLJX9lnVBqgYZf7eGeTxNzLGHqM"
    public company: Company = companyData
    public currencyExchange: CurrencyExchange = testCurrencyExchangeData
    public bankConnection: BankConnection = bankConnection

    /** USERS */
    public mainUser: User = new User(mainUserData)
    public ceoUser: User = new User(ceoUserData)
    public cpoUser: User = new User(cpoUserData)
    public ctoUser: User = new User(ctoUserData)
    public cfoUser: User = new User(cfoUserData)
    public teamLeadUser: User = new User(teamLeadData)
    public devUser: User = new User(devUserData)
    public designerUser: User = new User(designerUserData)
    public internUser: User = new User(internUserData)
    public devInternUser: User = new User(devInternUserData)
    public financeUser: User = new User(financeUserData)

    public users: User[] = [
        this.mainUser,
        this.ceoUser,
        this.cpoUser,
        this.ctoUser,
        this.cfoUser,
        this.teamLeadUser,
        this.devUser,
        this.designerUser,
        this.internUser,
        this.devInternUser,
        this.financeUser,
    ]

    /** COST CENTERS */
    public ccOfficeSupplies: CostCenter
    public ccFood: CostCenter
    public ccSoftware: CostCenter
    public ccHardware: CostCenter
    public costCenters: CostCenter[]

    /** VENDORS */
    public vendorAmazon: Vendor
    public vendorMicrosoft: Vendor
    public vendorEbay: Vendor
    public vendorSlack: Vendor
    public vendorGoogle: Vendor
    public vendorTelecom: Vendor
    public vendorAdobe: Vendor
    public vendors: Vendor[]

    /** EXPENSES */
    public deskExpense: Expense
    public lampExpense: Expense
    public cameraExpense: Expense
    public macbookExpense: Expense
    public serverExpense: Expense
    public monitorExpense: Expense
    public coffeeExpense: Expense
    public awsSub: Expense
    public primeSub: Expense
    public githubSub: Expense
    public slackSub: Expense
    public gcpSub: Expense
    public officeSub: Expense
    public expenses: Expense[]

    /** ACTIVITIES */
    public activity: Activity = activity
    public activities: Activity[] = [this.activity]

    /** EXPENSE ACCOUNTS */
    public expenseAccount: ExpenseAccount = expenseAccount
    public expenseAccounts: ExpenseAccount[] = [this.expenseAccount]

    /** PAYMENT PLANS */
    public paymentPlan: PaymentPlans = paymentPlan
    public paymentPlans: PaymentPlans[] = [this.paymentPlan]

    /** PAYMENTS */
    public payment: Payment = payment
    public payments: Payment[] = [this.payment]

    public constructor() {
        this.init()
    }

    public findById(items: any[], id: string) {
        return items.find((item) => item.id === id)
    }

    private init(): void {
        this.initCCs()
        this.initVendors()
        this.initExpenses()
    }

    private initCCs(): void {
        this.ccOfficeSupplies = {
            _id: "10",
            id: "10",
            name: "Office Supplies",
            responsibleUser: this.cpoUser.id,
            budgetValue: 200,
            budgetCurrency: CurrencyEnum.USD,
            budgetPeriod: BudgetPeriodEnum.MONTHLY,
        } as CostCenter
        this.ccFood = {
            _id: "20",
            id: "20",
            name: "Food",
            responsibleUser: this.cpoUser.id,
            budgetValue: 500,
            budgetCurrency: CurrencyEnum.USD,
            budgetPeriod: BudgetPeriodEnum.MONTHLY,
        } as CostCenter
        this.ccSoftware = {
            _id: "30",
            id: "30",
            name: "Software",
            responsibleUser: this.ceoUser.id,
            budgetValue: 2000,
            budgetCurrency: CurrencyEnum.USD,
            budgetPeriod: BudgetPeriodEnum.MONTHLY,
        } as CostCenter
        this.ccHardware = {
            _id: "40",
            id: "40",
            name: "Hardware",
            responsibleUser: this.ceoUser.id,
            budgetValue: 2000,
            budgetCurrency: CurrencyEnum.USD,
            budgetPeriod: BudgetPeriodEnum.MONTHLY,
        } as CostCenter
        this.costCenters = [this.ccOfficeSupplies, this.ccFood, this.ccSoftware, this.ccHardware]
    }

    private initVendors(): void {
        vendorAmazonData.createdBy = this.financeUser.id
        vendorAmazonData.comments = [{ postedBy: this.financeUser.id, message: "Fast and reliable vendor", datePosted: Date.now(), isAutoGenerated: false }]
        this.vendorAmazon = new Vendor(vendorAmazonData)
        vendorMicrosoftData.createdBy = this.financeUser.id
        this.vendorMicrosoft = new Vendor(vendorMicrosoftData)
        vendorEbayData.createdBy = this.financeUser.id
        vendorEbayData.comments = [
            { postedBy: this.devUser.id, message: "Too much scam, vendor has been difficult to work with in the past.", datePosted: Date.now(), isAutoGenerated: false },
        ]
        this.vendorEbay = new Vendor(vendorEbayData)
        vendorSlackData.createdBy = this.financeUser.id
        this.vendorSlack = new Vendor(vendorSlackData)
        vendorGoogleData.createdBy = this.financeUser.id
        this.vendorGoogle = new Vendor(vendorGoogleData)
        vendorTelecomData.createdBy = this.financeUser.id
        this.vendorTelecom = new Vendor(vendorTelecomData)
        vendorAdobeData.createdBy = this.financeUser.id
        vendorAdobeData.comments = [{ postedBy: this.cpoUser.id, message: "Approved", datePosted: Date.now(), isAutoGenerated: false }]
        this.vendorAdobe = new Vendor(vendorAdobeData)
        this.vendors = [this.vendorAdobe, this.vendorAmazon, this.vendorEbay, this.vendorGoogle, this.vendorMicrosoft, this.vendorSlack, this.vendorTelecom]
    }

    private initExpenses(): void {
        expenseDataDesk.costCenter = this.ccOfficeSupplies.id
        expenseDataDesk.vendor = this.vendorAmazon.id
        expenseDataDesk.requestedBy = this.devUser.id
        expenseDataDesk.createdBy = this.devUser.id
        expenseDataDesk.approvalNeededBy = this.teamLeadUser.id
        expenseDataDesk.comments = [{ postedBy: this.teamLeadUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true }]
        this.deskExpense = new Expense(expenseDataDesk)

        expenseDataLamp.costCenter = this.ccOfficeSupplies.id
        expenseDataLamp.vendor = this.vendorAmazon.id
        expenseDataLamp.requestedBy = this.devUser.id
        expenseDataLamp.createdBy = this.devUser.id
        expenseDataLamp.approvalNeededBy = this.teamLeadUser.id
        expenseDataLamp.comments = [
            { postedBy: this.financeUser.id, message: "approved the purchase request", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.devUser.id, message: "uploaded an invoice file.", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true },
        ]
        this.lampExpense = new Expense(expenseDataLamp)

        expenseDataCamera.costCenter = this.ccHardware.id
        expenseDataCamera.vendor = this.vendorAmazon.id
        expenseDataCamera.requestedBy = this.devUser.id
        expenseDataCamera.createdBy = this.devUser.id
        expenseDataCamera.approvalNeededBy = this.teamLeadUser.id
        expenseDataCamera.comments = [
            { postedBy: this.financeUser.id, message: "approved the purchase request", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.devUser.id, message: "uploaded an invoice file.", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true },
        ]
        this.cameraExpense = new Expense(expenseDataCamera)

        expenseDataMacbook.costCenter = this.ccHardware.id
        expenseDataMacbook.vendor = this.vendorEbay.id
        expenseDataMacbook.requestedBy = this.devUser.id
        expenseDataMacbook.createdBy = this.devUser.id
        expenseDataMacbook.approvalNeededBy = this.teamLeadUser.id
        expenseDataMacbook.comments = [
            { postedBy: this.financeUser.id, message: "rejected the purchase request", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: "Please buy a windows notebook..", datePosted: Date.now(), isAutoGenerated: false },
        ]
        this.macbookExpense = new Expense(expenseDataMacbook)

        expenseDataServer.costCenter = this.ccHardware.id
        expenseDataServer.vendor = this.vendorAmazon.id
        expenseDataServer.requestedBy = this.teamLeadUser.id
        expenseDataServer.createdBy = this.teamLeadUser.id
        expenseDataServer.approvalNeededBy = this.financeUser.id
        expenseDataServer.comments = [
            { postedBy: this.financeUser.id, message: "approved the purchase request", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: "Please attach the invoice to this request or email it to me.", datePosted: Date.now(), isAutoGenerated: false },
        ]
        this.serverExpense = new Expense(expenseDataServer)

        expenseDataMonitor.costCenter = this.ccHardware.id
        expenseDataMonitor.vendor = this.vendorEbay.id
        expenseDataMonitor.requestedBy = this.financeUser.id
        expenseDataMonitor.createdBy = this.financeUser.id
        expenseDataMonitor.approvalNeededBy = this.cfoUser.id
        this.monitorExpense = new Expense(expenseDataMonitor)

        expenseDataCoffee.costCenter = this.ccFood.id
        expenseDataCoffee.vendor = this.vendorEbay.id
        expenseDataCoffee.requestedBy = this.internUser.id
        expenseDataCoffee.createdBy = this.internUser.id
        expenseDataCoffee.approvalNeededBy = this.financeUser.id
        this.coffeeExpense = new Expense(expenseDataCoffee)

        expenseAWSSubscription.costCenter = this.ccSoftware.id
        expenseAWSSubscription.vendor = this.vendorAmazon.id
        expenseAWSSubscription.requestedBy = this.devUser.id
        expenseAWSSubscription.createdBy = this.financeUser.id // finance user created this expense for the dev user
        expenseAWSSubscription.approvalNeededBy = this.teamLeadUser.id
        expenseAWSSubscription.comments = [{ postedBy: this.teamLeadUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true }]
        this.awsSub = new Expense(expenseAWSSubscription)

        expensePrimeSubscription.costCenter = this.ccOfficeSupplies.id
        expensePrimeSubscription.vendor = this.vendorAmazon.id
        expensePrimeSubscription.requestedBy = this.financeUser.id
        expensePrimeSubscription.createdBy = this.financeUser.id
        expensePrimeSubscription.approvalNeededBy = this.cfoUser.id
        expensePrimeSubscription.comments = [
            { postedBy: this.cfoUser.id, message: "approved the purchase request", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: " uploaded an invoice file.", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.cfoUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true },
        ]
        this.primeSub = new Expense(expensePrimeSubscription)

        expenseGithubSubscription.costCenter = this.ccSoftware.id
        expenseGithubSubscription.vendor = this.vendorMicrosoft.id
        expenseGithubSubscription.requestedBy = this.devUser.id
        expenseGithubSubscription.createdBy = this.devUser.id
        expenseGithubSubscription.approvalNeededBy = this.teamLeadUser.id
        expenseAWSSubscription.comments = [
            { postedBy: this.financeUser.id, message: "uploaded an invoice file.", datePosted: Date.now(), isAutoGenerated: true },
            { postedBy: this.financeUser.id, message: "approved the invoice request", datePosted: Date.now(), isAutoGenerated: true },
        ]
        this.githubSub = new Expense(expenseGithubSubscription)

        expenseSlackSubscription.costCenter = this.ccSoftware.id
        expenseSlackSubscription.vendor = this.vendorSlack.id
        expenseSlackSubscription.requestedBy = this.devUser.id
        expenseSlackSubscription.createdBy = this.devUser.id
        expenseSlackSubscription.approvalNeededBy = this.teamLeadUser.id
        this.slackSub = new Expense(expenseSlackSubscription)

        expenseGCPSubscription.costCenter = this.ccSoftware.id
        expenseGCPSubscription.vendor = this.vendorGoogle.id
        expenseGCPSubscription.requestedBy = this.devUser.id
        expenseGCPSubscription.createdBy = this.devUser.id
        expenseGCPSubscription.approvalNeededBy = this.teamLeadUser.id
        this.gcpSub = new Expense(expenseGCPSubscription)

        expenseMSOfficeSubscription.costCenter = this.ccSoftware.id
        expenseMSOfficeSubscription.vendor = this.vendorMicrosoft.id
        expenseMSOfficeSubscription.requestedBy = this.devInternUser.id
        expenseMSOfficeSubscription.createdBy = this.devInternUser.id
        expenseMSOfficeSubscription.approvalNeededBy = this.teamLeadUser.id
        this.officeSub = new Expense(expenseMSOfficeSubscription)

        this.expenses = [
            this.deskExpense,
            this.lampExpense,
            this.cameraExpense,
            this.macbookExpense,
            this.serverExpense,
            this.monitorExpense,
            this.coffeeExpense,
            this.awsSub,
            this.primeSub,
            this.githubSub,
            this.slackSub,
            this.gcpSub,
            this.officeSub,
        ]
    }

    public get paginatedExpenses(): any {
        return {
            docs: this.expenses,
            totalPages: 1,
            totalDocs: this.expenses.length,
        }
    }

    public get authTokens(): any {
        return {
            accessToken: this.adminAccessToken,
            refreshToken: this.adminRefreshToken,
        }
    }

    /** ANALYTICS */
    public get expenseCountsAnalytics(): any {
        return {
            toDo: this.expenses.filter(
                (item) => item.status === ExpenseStatusEnum.PURCHASE_PENDING || item.status === ExpenseStatusEnum.DOCS_NEEDED || item.status == ExpenseStatusEnum.INVOICE_PENDING
            ).length,
            review: this.expenses.filter((item) => item.status === ExpenseStatusEnum.APPROVED).length,
            payExport: this.expenses.filter((item) => item.status === ExpenseStatusEnum.REVIEWED || item.status == ExpenseStatusEnum.PAID).length,
            all: this.expenses.length,
        }
    }

    public get analyticsOverview(): any {
        return {
            currentMonthTotal: 14578,
            currentQuarterTotal: 45654,
            currentYearTotal: 3141596,
        }
    }

    public get expensesCostCenterOvertime(): any[] {
        return [
            {
                name: this.ccFood.name,
                data: [
                    {
                        year: 2020,
                        month: 10,
                        expenseTotal: 566546,
                    },
                ],
            },
        ]
    }

    public get costCentersOvertime(): any[] {
        return this.costCenters.map(function (item) {
            return {
                costCenter: item.name,
                data: [
                    {
                        year: 2020,
                        month: 10,
                        expenseTotal: 566546,
                    },
                ],
            }
        })
    }

    public get costCentersEmployee(): any[] {
        return [
            {
                name: "Name",
                value: 1546,
            },
        ]
    }

    public get costCenterBudgets(): any[] {
        return this.costCenters.map(function (item) {
            return {
                id: item._id,
                capacity: 3141592,
                consumption: 2718281,
                forecaset: 3141591,
            }
        })
    }

    public get groupedExpensesPerUser(): any[] {
        return [
            {
                id: this.ctoUser.id,
                value: 456654,
                amount: 4,
            },
        ]
    }

    public get groupedExpensesPerCostCenter(): any[] {
        return [
            {
                id: this.ccFood.id,
                value: 456654,
                amount: 4,
            },
        ]
    }
}
